import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import IGetActiveKhataratEzafiQuery from 'Feature/Common/Common/Types/Queries/IGetActiveKhataratEzafiQuery';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getActiveKhataratEzafi = createAsyncThunk(
  'KhatarEzafi/getActiveKhataratEzafi',
  async (query: IGetActiveKhataratEzafiQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.KhatarEzafi.GetActiveKhataratEzafi}`,
      params: query,
    });
  }
);
